import React, { useEffect, useState } from "react";
import Hero from "@/components/Hero";
import TrustBadges from "@/components/TrustBadges";
import ServiceGrid from "@/components/ServiceGrid";
import PromoBannerGrid from "@/components/PromoBannerGrid";
import WhyChooseUs from "@/components/WhyChooseUs";
import StatsCounter from "@/components/StatsCounter";
import TestimonialsSection from "@/components/TestimonialsSection";
import GoogleReviews from "@/components/GoogleReviews";
import FAQSection from "@/components/FAQSection";
import SEOHead from "@/components/SEOHead";
import api from "@/lib/api";

const DEFAULT_VISIBILITY = {
  trust_badges: true, promo_banners: true, why_choose_us: true,
  stats_counter: true, testimonials: true, google_reviews: true, faq: true,
};

export default function Home() {
  const [visibility, setVisibility] = useState(DEFAULT_VISIBILITY);
  const [orgSchema, setOrgSchema] = useState(null);
  const [faqTitle, setFaqTitle] = useState("Frequently Asked Questions");

  useEffect(() => {
    api.get("/site-settings").then((res) => {
      if (res.data.section_visibility) setVisibility(res.data.section_visibility);
      if (res.data.homepage_content?.faq?.title) setFaqTitle(res.data.homepage_content.faq.title);
      const s = res.data;
      setOrgSchema({
        "@context": "https://schema.org",
        "@type": "TravelAgency",
        "name": "Gulfudaan",
        "url": window.location.origin,
        "logo": s.logo_url || undefined,
        "image": s.logo_url || undefined,
        "description": s.footer_tagline || "Trusted GAMCA appointments, dummy tickets, Saudi VFS & Gulf visa services.",
        "telephone": s.phone || undefined,
        "email": s.email || undefined,
        "address": s.address ? { "@type": "PostalAddress", "streetAddress": s.address } : undefined,
        "sameAs": Object.values(s.social_links || {}).filter(Boolean),
        "aggregateRating": s.google_rating ? {
          "@type": "AggregateRating",
          "ratingValue": s.google_rating,
          "reviewCount": s.google_review_count || 1,
        } : undefined,
      });
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <SEOHead pageKey="home" schema={orgSchema} />
      <Hero />
      {visibility.trust_badges && <TrustBadges />}
      <ServiceGrid />
      {visibility.promo_banners && <PromoBannerGrid />}
      {visibility.why_choose_us && <WhyChooseUs />}
      {visibility.stats_counter && <StatsCounter />}
      {visibility.testimonials && <TestimonialsSection />}
      {visibility.google_reviews && <GoogleReviews />}
      {visibility.faq && <FAQSection title={faqTitle} />}
    </div>
  );
}
